import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { TeachCard } from "@/components/training/TeachCard";
import { NotesList } from "@/components/training/NotesList";
import { SitesCard } from "@/components/training/SitesCard";
import { TestAssistantCard } from "@/components/training/TestAssistantCard";

export default function EntrenarPage() {
  const [editing, setEditing] = useState(null);
  const teachRef = useRef(null);
  return (
    <div className="h-full overflow-y-auto" data-testid="entrenar-page">
      <div className="p-4 sm:p-6 lg:p-8 max-w-[1200px] mx-auto">
        <div className="mb-6">
          <h1 className="font-display text-3xl font-normal text-[#1A1A1A]">Entrenar asistente</h1>
          <p className="text-sm text-[#8A7E70] mt-1 max-w-[680px]">
            Todo lo que añadas aquí lo usa el asistente al instante en WhatsApp e Instagram. Para información fija y documentos
            (tratamientos, tarifas, PDF), usa la <Link to="/conocimiento" className="underline text-[#1A1A1A]" data-testid="entrenar-kb-link">Base de conocimientos</Link>.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 items-start">
          <div className="space-y-5">
            <TeachCard cardRef={teachRef} editing={editing} onDone={() => setEditing(null)} />
            <NotesList onEdit={(n) => { setEditing(n); setTimeout(() => teachRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 50); }} />
          </div>
          <div className="space-y-5 lg:sticky lg:top-4">
            <TestAssistantCard />
            <SitesCard />
          </div>
        </div>
      </div>
    </div>
  );
}
